import { type ReviewActionT } from '../../../../common/review-action/constants';
import type { AnnotationLabelT, AnnotationUnderUserReviewT, GenericAnnotationReviewDataT, RangeSpanT } from '../../../../common/types/types';
import { type StoreTypeT } from '../../../../common/types/types';
import type { AnnotationT, BulkAnnotationT, EditorModeT } from '../../types';
import type { LabelStateT } from '../../types';
import type { MultiSelectActionsT } from './multi-select';
import type { RelationshipActionsT } from './relationship';
export type FrameSpanT = {
  startFrame: number;
  endFrame: number;
};
export type AddAnnotationActionT = {
  type: 'ADD_ANNOTATION';
  frameIndex: number;
  annotationIdx: string;
  annotationData: AnnotationT;
  annotationReviewData?: GenericAnnotationReviewDataT;
};
export type AddAnnotationUnderReviewActionT = {
  type: 'ADD_ANNOTATION_UNDER_REVIEW';
  annotation: AnnotationUnderUserReviewT;
  annotationId: string;
};
export type UpdateAnnotationUnderReviewActionT = {
  type: 'UPDATE_ANNOTATION_UNDER_REVIEW';
  annotation: Partial<AnnotationUnderUserReviewT>;
  annotationId: string;
};
export type DeleteAnnotationUnderReviewActionT = {
  type: 'DELETE_ANNOTATION_UNDER_REVIEW';
  annotationIds: string[];
};
export type AddAnnotationUnderReviewPayloadT = Omit<AddAnnotationUnderReviewActionT, 'type'>;
export type AddAnnotationsActionT = {
  type: 'ADD_ANNOTATIONS';
};
export type UpdateAnnotationActionT = {
  type: 'UPDATE_ANNOTATION';
  frameIndex: number;
  annotationIdx: string;
  annotationData: AnnotationT;
};
export type DeleteAnnotationActionT = {
  type: 'DELETE_ANNOTATION';
  frameIndex: number;
  annotationIdx: string;
};
export type DeleteAnnotationsActionT = {
  type: 'DELETE_ANNOTATIONS';
  currentFrame?: number;
  annotationLabels?: string[];
};
export type DeleteAnnotationFrameSpanActionT = {
  type: 'DELETE_ANNOTATION_FRAME_SPAN';
  frameSpan: RangeSpanT;
  annotationIdx: string;
};
export type LockAnnotationsPayloadT = {
  annotationId?: string;
  annotationLabel?: AnnotationLabelT;
  allAnnotations?: boolean;
  locked: boolean;
  storeType?: StoreTypeT;
  frameIndex?: number;
  frameRange?: [number, number][];
};
export type ShowHideAnnotationsPayloadT = {
  annotationId?: string;
  annotationLabel?: string;
  allAnnotations?: boolean;
  hidden: boolean;
  storeType?: StoreTypeT;
  frameIndex?: number;
  frameRange?: [number, number][];
  annotationLabels?: AnnotationLabelT[];
};
export type ShowHideAnnotationsActionT = {
  type: 'SHOW_HIDE_ANNOTATIONS';
} & ShowHideAnnotationsPayloadT;
export type UpdateLabelColorPayloadT = {
  color: string;
  title: string;
};
export type UpdateAllAnnotationLabelsPayloadT = {
  annotationLabels: AnnotationLabelT[];
};
export type UpdateLabelColorT = {
  type: 'UPDATE_ANNOTATION_LABELS';
} & UpdateLabelColorPayloadT;
export type UpdateAllAnnotationLabelsT = {
  type: 'UPDATE_ALL_ANNOTATION_LABELS';
} & UpdateAllAnnotationLabelsPayloadT;
export type ShowAnnotationRelationshipGraphT = {
  type: 'TOGGLE_ANNOTATION_RELATIONSHIP_VIEW';
  editorMode: EditorModeT;
};
export type ImportAnnotationsActionT = {
  type: 'IMPORT_ANNOTATIONS';
  frameIndex: number;
  annotationIdList: string[];
  reviewAction?: ReviewActionT;
};
export type BulkAddAnnotationsActionT = {
  type: 'BULK_ADD_ANNOTATIONS';
  annotations: BulkAnnotationT[];
};
export type CopyAnnotationIdActionT = {
  type: 'COPY_ANNOTATION_ID';
  annotationId: string | null;
};
export type UpdateAllAnnotationFrameSpanT = {
  type: 'UPDATE_ALL_ANNOTATION_FRAME_SPAN';
  annotationIdx: string;
  startFrame: number;
  endFrame: number;
};
export type ActionT = AddAnnotationActionT | AddAnnotationsActionT | ShowAnnotationRelationshipGraphT | BulkAddAnnotationsActionT | UpdateAnnotationActionT | DeleteAnnotationActionT | DeleteAnnotationsActionT | {
  type: 'CREATE_VIDEO_FRAMES';
  frames: LabelStateT['frames'];
} | UpdateAllAnnotationFrameSpanT | {
  type: 'DELETE_ANNOTATION_FRAME_SPAN';
  annotationIdx: string;
  frameSpan: RangeSpanT;
} | {
  type: 'DELETE_ANNOTATION_REVIEW';
  frameIndex: number;
  annotationId: string;
} | ImportAnnotationsActionT | RelationshipActionsT | MultiSelectActionsT | BulkAddAnnotationsActionT;